<template>
  <div class="card-table-wrap">
    <empty v-show="paging.total === 0" description="暂无数据"></empty>
    <div v-show="paging.total !== 0" class="card-table">
      <el-row>
        <el-col v-for="(item, index) in tableData" :key="index" :span="6">
          <card-item
            :data="item"
            :meta-title="itemMetaTitle"
            :meta-data="itemMetaData"
            :operator="operator"
          >
            <template
              v-for="(sItem, sIndex) in itemMetaData"
              :slot="sItem.slotName"
              slot-scope="{ param }"
            >
              <slot v-if="sItem.slotName" :name="sItem.slotName" :param="param"></slot>
            </template>
          </card-item>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <pagination
        :paging="paging"
        :layout="showPagination ? 'total, prev, pager, next, sizes, jumper' : 'total'"
        @paginationChanged="onPageChanged"
      ></pagination>
      <!-- 分页 -->
    </div>
  </div>
</template>
<script>
import CardItem from './cardItem.vue'
import Pagination from '../normalTable/pagination.vue'
export default {
  name: 'CardTable',
  components: {
    CardItem: CardItem,
    Pagination: Pagination
  },
  props: {
    itemMetaTitle: {
      type: Object,
      default: () => {}
    },
    itemMetaData: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    operator: {
      type: Array,
      default: () => []
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    paging: {
      type: Object,
      default: () => {
        return {
          total: 0,
          offset: 0,
          limit: 10
        }
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    onPageChanged(info) {
      this.loading = true
      this.$emit('pagination', info)
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.card-table-wrap {
  @include adaptation(
    (
      --cbaas-card-table-padding-bottom: 80px,
      --cbaas-card-table-no-paggination-padding-bottom: 40px,
      --cbaas-card-table-margin: 0 -8px,
      --cbaas-card-table-col-padding: 0 8px,
      --cbaas-card-table-col-margin-bottom: 16px
    )
  );
  height: 100%;
  position: relative;

  .card-table {
    height: 100%;
    padding-bottom: var(--cbaas-card-table-padding-bottom);

    &.no-paggination {
      padding-bottom: var(--cbaas-card-table-no-paggination-padding-bottom);
    }

    .el-row {
      margin: var(--cbaas-card-table-margin);

      .el-col {
        padding: var(--cbaas-card-table-col-padding);
        margin-bottom: var(--cbaas-card-table-col-margin-bottom);
      }
    }
  }
}
</style>
